function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useEffect, Fragment } from "react";
export function EventSetter(param) {
    var children = param.children, containerRef = param.containerRef, onDismiss = param.onDismiss, _shouldDismissOnMissing = param.shouldDismissOnMissing, shouldDismissOnMissing = _shouldDismissOnMissing === void 0 ? false : _shouldDismissOnMissing;
    useEffect(function() {
        var cancel = false;
        var handleWindowClick = function(event) {
            if (_instanceof(containerRef.current, Element) && !containerRef.current.contains(event.target) && (shouldDismissOnMissing || document.contains(event.target)) && typeof onDismiss === 'function') {
                onDismiss(event);
            }
        };
        window.requestAnimationFrame(function() {
            if (!cancel) {
                window.addEventListener('click', handleWindowClick);
            }
        });
        return function() {
            cancel = true;
            window.removeEventListener('click', handleWindowClick);
        };
    }, [
        containerRef,
        onDismiss,
        shouldDismissOnMissing
    ]);
    return _jsx(Fragment, {
        children: children
    });
}
export default EventSetter;
